import LyRouteButton from './src/index.vue'

LyRouteButton.install = function (Vue) {
    Vue.component(LyRouteButton.name, LyRouteButton)
}

export default LyRouteButton



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/route-button/index.js
// module id = null
// module chunks = 